
export interface MockPhoto {
  id: string;
  filename: string;
  storageUrl: string;
  event: {
    title: string;
  };
  price: number;
  tags: string[];
  bibNumbers: string[];
}

// Gerar dados mockados
const generateMockPhotos = (): MockPhoto[] => {
  const photos: MockPhoto[] = [];
  const events = [
    'Maratona Rio 2024', 'Corrida da Paz', 'Ironman 2024', 
    'Corrida Noturna', 'Corrida Kids', 'Triathlon Sul',
    'Meia Maratona SP', 'Volta da Pampulha'
  ];
  const tagsList = ['largada', 'chegada', 'pódio', 'percurso', 'torcida', 'medalha'];

  for (let i = 1; i <= 200; i++) {
    const eventIndex = Math.floor(Math.random() * events.length);
    const numTags = Math.floor(Math.random() * 3) + 1;
    const photoTags: string[] = [];
    for (let j = 0; j < numTags; j++) {
      photoTags.push(tagsList[Math.floor(Math.random() * tagsList.length)]);
    }

    photos.push({
      id: i.toString(),
      filename: `photo_${i}.jpg`,
      storageUrl: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150',
      event: { title: events[eventIndex] },
      price: Math.floor(Math.random() * 20) + 5,
      tags: photoTags,
      bibNumbers: [Math.floor(Math.random() * 1000).toString(), Math.floor(Math.random() * 1000).toString()]
    });
  }
  return photos;
};

const MOCK_PHOTOS = generateMockPhotos();

export const MockPhotoService = {
  search: async (query: string, limit: number = 20, offset: number = 0) => {
    // Simular delay de rede
    await new Promise(resolve => setTimeout(resolve, 1500));

    const lowerQuery = query.toLowerCase();
    
    const filtered = MOCK_PHOTOS.filter(photo => {
      const matchesEvent = photo.event.title.toLowerCase().includes(lowerQuery);
      const matchesTag = photo.tags.some(tag => tag.toLowerCase().includes(lowerQuery));
      const matchesBib = photo.bibNumbers.some(bib => bib.includes(lowerQuery));
      
      return matchesEvent || matchesTag || matchesBib;
    });

    return {
      photos: filtered.slice(offset, offset + limit),
      total: filtered.length,
      hasMore: offset + limit < filtered.length
    };
  }
};
